import React, {useEffect, useState} from 'react';
import {Button} from 'primereact/button';
import {Password} from 'primereact/password';
import {Divider} from "primereact/divider";
import {UuserService} from "../service/UuserService";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GeneralUtils from "../utils/GeneralUtils";
import SHA256 from "crypto-js/sha256";


const PasswordChange = (props) => {
    const service = new UuserService();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');


    const header = <div className="font-bold mb-3">Şifre belirle</div>;
    const footer = (
        <>
            <Divider/>
            <p className="mt-2">Tavsiyeler</p>
            <ul className="pl-2 ml-2 mt-0 line-height-3">
                <li>En az bir küçük harf</li>
                <li>En az bir büyük harf</li>
                <li>En az bir rakam</li>
                <li>En az 8 karakter</li>
            </ul>
        </>
    );


    const submitPasswordChange = () => {
        if (GeneralUtils.isNullOrEmpty(currentPassword) || GeneralUtils.isNullOrEmpty(newPassword) || GeneralUtils.isNullOrEmpty(confirmPassword)) {
            return toast.warn('Lütfen tüm alanlarını doldurun.');
        }
        if (newPassword !== confirmPassword) {
            return toast.error('Yeni şifreler eşleşmiyor. Lütfen tekrar deneyin.');

        }
        if (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(newPassword) === false) {
            return toast.warn('Lütfen geçerli bir şifre girin.');

        }
        const user = GeneralUtils.getUser();
        const data = {
            email: user.email,
            currentPassword: SHA256(currentPassword).toString(),
            newPassword: SHA256(newPassword).toString()
        };

        service.changePassword(data).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)){
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
                if(props.closeDialog){
                    props.closeDialog();
                }
            }
        });
    };


    return (
        <div className="flex flex-column gap-2 m-4">
            <Password placeholder="Mevcut şifreyi girin" value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)} feedback={false}
                      className="p-inputtext-sm" toggleMask/>
            <Password placeholder="Yeni şifreyi girin" value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)} header={header} footer={footer}
                      className="p-inputtext-sm"
                      toggleMask/>
            <Password placeholder="Yeni şifreyi yeniden yazın" value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)} feedback={false}
                      className="p-inputtext-sm" toggleMask/>
            <Button label="Şifreyi değiştirin" onClick={submitPasswordChange} size="sm"
                    style={{width: "100%"}}/>
        </div>
    )
}

export default PasswordChange;